import React from "react";
import { motion } from "framer-motion";
import {
  Award,
  Sparkles,
  Users,
  Building2,
  Briefcase,
  GraduationCap,
} from "lucide-react";

const items = [
  {
    icon: Award,
    title: "Certificación I.E.E.",
    desc: "Diplomas con validez en el sector beauty y aval profesional para impulsar tu carrera.",
  },
  {
    icon: Sparkles,
    title: "Prácticas reales",
    desc: "Desde el primer mes practicas con modelos reales bajo supervisión directa.",
  },
  {
    icon: Users,
    title: "Profesores expertos",
    desc: "Estilistas y barberos en activo, con experiencia editorial y de salón premium.",
  },
  {
    icon: Building2,
    title: "Instalaciones premium",
    desc: "Aulas equipadas con herramientas profesionales en cada una de las 6 sucursales.",
  },
  {
    icon: Briefcase,
    title: "Emprende tu propio negocio",
    desc: "Te capacitamos para generar ingresos desde que estudias y, al terminar, lanzar tu propio salón, barbería o estudio.",
  },
  {
    icon: GraduationCap,
    title: "Aprendizaje desde cero",
    desc: "No necesitas experiencia previa. Te llevamos paso a paso hasta el nivel profesional.",
  },
];

export default function Benefits() {
  return (
    <section
      id="beneficios"
      className="section bg-white"
      data-testid="benefits-section"
    >
      <div className="container-ie">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start mb-8 md:mb-14">
          <div className="md:col-span-6">
            <div className="flex items-center gap-3 mb-5">
              <span className="dot-red" />
              <span className="overline">Por qué Instituto Europa</span>
            </div>
            <h2 className="font-display font-semibold tracking-tighter text-4xl md:text-5xl lg:text-6xl text-[#0a0a0a]">
              Una formación
              <br /> de <span className="italic font-light">otro nivel.</span>
            </h2>
          </div>
          <div className="md:col-span-6">
            <p className="text-base md:text-lg font-light text-[#525252] leading-relaxed">
              Cada detalle de nuestro instituto está pensado para hacerte
              destacar en el mercado profesional de la belleza. No formamos
              aficionados — formamos profesionales.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-black/8">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                className="border-b border-r border-black/8 p-8 md:p-10 bg-white hover:bg-[#fafafa] transition-colors group"
                data-testid={`benefit-${i}`}
              >
                <div className="w-12 h-12 flex items-center justify-center border border-black/10 group-hover:border-[#c40000] group-hover:text-[#c40000] transition-colors">
                  <Icon size={20} strokeWidth={1.5} />
                </div>
                <h3 className="mt-6 font-display font-semibold text-xl tracking-tight text-[#0a0a0a]">
                  {it.title}
                </h3>
                <p className="mt-3 text-sm font-light text-[#525252] leading-relaxed">
                  {it.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
